import { gql } from "@apollo/client";
import { DEDUCTION_FRAGMENT } from "./deductionFragment";

const SEND_FOR_APPROVAL_BULK = gql`
  ${DEDUCTION_FRAGMENT}
  mutation SendApprovalBulk($params: BulkSendApprovalParams!) {
    bulkSendForApproval(params: $params) {
      ...DeductionFields
    }
  }
`;

export default SEND_FOR_APPROVAL_BULK;